// src/components/common/PlanLimitBadge.jsx
import React from 'react';

/**
 * Badge che mostra utilizzo / limite del piano
 * Es: 💰 Spese 4 / 100  oppure  4 / ∞
 *
 * Props:
 *   icon     — emoji o stringa
 *   label    — es. "Spese"
 *   used     — numero corrente
 *   max      — numero massimo (null o -1 = illimitato)
 *   warnAt   — percentuale per colore warning (default 80)
 */
const PlanLimitBadge = ({ icon, label, used, max, warnAt = 80 }) => {
    const unlimited = max === null || max === -1 || max === undefined;
    const pct = unlimited ? 0 : (used / max) * 100;
    const isOver = !unlimited && used >= max;
    const isWarn = !unlimited && pct >= warnAt;

    const color = isOver
        ? 'bg-red-50 border-red-200 text-red-700'
        : isWarn
            ? 'bg-amber-50 border-amber-200 text-amber-700'
            : 'bg-gray-50 border-gray-200 text-gray-600';

    const display = unlimited ? `${used} / ∞` : `${used} / ${max}`;

    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-medium ${color}`}>
            {icon && <span>{icon}</span>}
            {label && <span className="hidden sm:inline">{label}</span>}
            <span className="font-bold">{display}</span>
            {isOver && <span title="Limite raggiunto">🔴</span>}
        </span>
    );
};

export default PlanLimitBadge;